import { Entity, Pile, Resources } from "~/utils";
import {
  AgentEffectDescription,
  AgentIcon,
  Dreadnought,
  GameExtension,
  Meaple,
} from "~/business";

export type ActionSlotProps = Entity & {
  agentIcon: AgentIcon;
  cost?: Resources;
  isBattle?: boolean;
  isHarvest?: boolean;
  effects: AgentEffectDescription[];
  bonusSpice?: number;
  controlFlag?: string;
  meaples: Pile<Meaple>;
  controlEffect?: AgentEffectDescription;
  blockedBy?: string[];
  controlDreadnought?: Dreadnought;
  extension?: GameExtension;
};

export type ActionSlotDef = Omit<
  ActionSlotProps,
  "meaples" | "controller" | "blockedBy"
>;

export class ActionSlot implements ActionSlotProps {
  id: string;
  agentIcon: AgentIcon;
  cost?: Resources;
  isBattle?: boolean;
  isHarvest?: boolean;
  effects: AgentEffectDescription[];
  bonusSpice?: number;
  controlFlag?: string;
  meaples: Pile<Meaple>;
  controlEffect?: AgentEffectDescription;
  blockedBy?: string[];
  controlDreadnought?: Dreadnought;
  extension?: GameExtension;

  constructor(props: ActionSlotProps) {
    Object.assign(this, props);
  }
  get isControllable(): boolean {
    return Boolean(this.controlEffect);
  }
  get controller(): string | undefined {
    const { controlDreadnought, controlFlag } = this;
    return controlDreadnought?.owner ?? controlFlag;
  }
  static from(def: ActionSlotDef) {
    return new ActionSlot({ ...def, meaples: Pile.empty() });
  }
}
